export const PERCENT = "PERCENT";
export const ABSOLUTE = "ABSOLUTE";
